
export const sportsIconMap: Record<string, string | null> = {
  Cricket: '/icons/new/cricket.png',
  Soccer: '/icons/new/football.png',
  Football: '/icons/new/football.png',
  Tennis: '/icons/new/tennis.png',
  'Table Tennis': '/icons/new/table-tennis.png',
  Esoccer: '/icons/new/e-soccer.png',

  // Racing
  'Horse Racing': '/icons/new/horse.png',
  'Greyhound Racing': '/icons/new/gray.png',

  Basketball: '/icons/sports/basket-ball.webp',
  Wrestling: '/icons/sports/wrestling.webp',
  Volleyball: '/icons/sports/volleyball.webp',
  Badminton: '/icons/sports/badminton.webp',
  Snooker: '/icons/sports/snooker.webp',
  Darts: '/icons/sports/dart2.webp',
  Boxing: '/icons/sports/boxing.webp',
  'Mixed Martial Arts': '/icons/sports/boxing.webp',
  'American Football': '/icons/sports/american-football.webp',
  'E Games': '/icons/sports/e-games.webp',
  'Ice Hockey': '/icons/sports/ice-hockey.webp',
  Futsal: '/icons/sports/futsal.webp',

  // Other Sports
  Politics: '/icons/new/politics.png',
  'Motor Sports': '/icons/sports/motor-racing.webp',
  Kabaddi: '/icons/new/kabaddi.png',

  Inplay: '/icons/sports/inplay.png',
  Casino: '/icons/new/casino.png',
  'All Casino': '/icons/new/casino.png',
};

// Sports that have a page but no markets yet — the page shows a "coming soon" message
export const UPCOMING_SPORTS = ['Horse Racing', 'Greyhound Racing', 'Kabaddi', 'Politics'];

export const isUpcomingSport = (sportName?: string | null) =>
  !!sportName &&
  UPCOMING_SPORTS.some((s) => s.toLowerCase() === sportName.replace(/-/g, ' ').toLowerCase());

export const casinoProviders = [
  'ALL',
  'MAC88 GAMING',
  'MAC88 GAMING VIRTUAL',
  'MAC EXCITE',
  'SMARTSOFT',
  'SPRIBE',
  'EVOLUTION GAMING',
  'TURBO',
  'EZUGI',
  'JILI',
  'PLAYTECH',
  'BETSOFT',
  'GAMZIX',
  'BETGAMES',
  'EVOPLAY',
  'ASIA GAMING',
  'WINFINITY',
  'VIVOGAMING',
  'ROYAL GAMING',
];

export const gamesCategory = [
  { name: 'All', icon: null },
  { name: 'Aviator', icon: 'aviator.png' },
  { name: 'Mines', icon: 'mines.png' },
  { name: 'Color Game', icon: 'colorgame1.png' },
  { name: 'Dragon Tiger', icon: 'dragon-tiger1.png' },
  { name: 'Andar bahar', icon: 'andar-bahar1.png' },
  { name: 'Teenpatti', icon: 'teenpatti1.png' },
  { name: 'Lottery', icon: 'lottery.png' },
  { name: 'Live Lobby', icon: 'live-lobby1.png' },
  { name: 'Crash Game', icon: 'crash-game.png' },
  { name: 'Casual Game', icon: 'casual-game.png' },
  { name: 'Scratch Cards', icon: 'scratch-card.png' },
  { name: 'Live Blackjack', icon: 'live-blackjack.png' },
  { name: 'Live Baccarat', icon: 'live-bacarrat.png' },
  { name: 'Live Roulette', icon: 'live-roulette.png' },
  { name: 'Live Dice', icon: 'live-dice.png' },
  { name: 'Table', icon: 'live.png' },
  { name: 'Live', icon: 'live.png' },
  { name: 'Virtual', icon: 'live.png' },
  { name: 'Live Dealer', icon: 'live.png' },
  { name: 'Lobby', icon: 'live.png' },
  { name: 'Wheel of Fortune', icon: 'live.png' },
  { name: 'Baccarat', icon: 'live.png' },
  { name: 'Poker', icon: 'live-poker.png' },
  { name: 'Blackjack', icon: 'live-blackjack.png' },
  { name: 'Lucky7', icon: 'live.png' },
  { name: 'Roulette', icon: 'live-roulette.png' },
  { name: 'Sicbo', icon: 'live.png' },
  { name: 'Casual Games', icon: 'casual-game.png' },
  { name: 'Slot games', icon: 'slots.png' },
  { name: 'Bingo', icon: 'bingo.png' },
  { name: 'Hi Lo', icon: 'hi_low.png' },
  { name: 'Deal Or No Deal', icon: 'dealornodeal.png' },
  { name: 'Rummy', icon: 'rummy.png' },
  { name: 'Plinko', icon: 'live-sic-bo.png' },
  { name: 'Others', icon: 'others.png' },
];

export const categoryIconMap: Record<string, string> = {
  'Casual Games': '/images/casino/category/casual-game.svg',
  'Crash Games': '/images/casino/category/crash-game.svg',
  'Slot Games': '/images/casino/category/slot-game.svg',
  'Slot games': '/images/casino/category/slot-game.svg',
  'Video Slots': '/images/casino/category/slot-game.svg',
  Virtual: '/images/casino/category/slot-game.svg',
  Virtuals: '/images/casino/category/slot-game.svg',
  'Game Shows': '/images/casino/category/live-lobby.svg',
  'Game Show': '/images/casino/category/live-lobby.svg',
  Live: '/images/casino/category/live-lobby.svg',
  'Live Game Shows': '/images/casino/category/live-lobby.svg',

  'Live Roulette': '/images/casino/category/live-roulette.svg',
  'Live Lobby': '/images/casino/category/live-lobby.svg',
  'Live Poker': '/images/casino/category/live-poker.svg',
  'Live Blackjack': '/images/casino/category/live-blackjack.svg',
  'Live Baccarat': '/images/casino/category/live-baccarat.svg',
  'Live Dice': '/images/casino/category/live-dice.svg',
  'Live Crash': '/images/casino/category/crash-game.svg',
  'Live Dragon Tiger': '/images/casino/category/dragon-tiger.svg',
  'Dragon Tiger': '/images/casino/category/dragon-tiger.svg',

  andar_bahar: '/images/casino/category/andar-bahar.svg',
  Andarbahar: '/images/casino/category/andar-bahar.svg',
  Teenpatti: '/images/casino/category/teenpatti.svg',
  Lottery: '/images/casino/category/lottery.svg',
  'Live Lottery': '/images/casino/category/lottery.svg',

  Baccarat: '/images/casino/category/live-baccarat.svg',
  Blackjack: '/images/casino/category/live-blackjack.svg',
  roulette: '/images/casino/category/live-roulette.svg',
  Roulette: '/images/casino/category/live-roulette.svg',

  sicbo: '/images/casino/category/live-sic-bo.svg',
  'Live Sic Bo': '/images/casino/category/live-sic-bo.svg',
  'Live SicBo': '/images/casino/category/live-sic-bo.svg',

  Mines: '/images/casino/category/mines.svg',
  Plinko: '/images/casino/category/color-games.svg', // closest match visually (ball/drop)
  Bingo: '/images/casino/category/bingo.svg',
  'Color Games': '/images/casino/category/color-games.svg',
  Aviator: '/images/casino/category/aviator.svg',
  'Deal or No Deal': '/images/casino/category/dealornodeal.svg',
  Rummy: '/images/casino/category/rummy.svg',
  'Scratch Card': '/images/casino/category/scratch-card.svg',
  'Scratch Cards': '/images/casino/category/scratch-card.svg',

  'Table Games': '/images/casino/category/sidebarOverlay.svg',
  Table: '/images/casino/category/sidebarOverlay.svg',

  Others: '/images/casino/category/three-cards.svg',
  'Top Card': '/images/casino/category/three-cards.svg',
  Unknown: '/images/casino/category/three-cards.svg',
  'Arcade Game': '/images/casino/category/three-cards.svg',
  'Arcade Games': '/images/casino/category/three-cards.svg',
  card: '/images/casino/category/three-cards.svg',
  casino: '/images/casino/category/three-cards.svg',
  Casino: '/images/casino/category/three-cards.svg',
  'Fish Shooting': '/images/casino/category/three-cards.svg',
};

// use on home page
const assetBase = '/images';
export const newProviderCards = [
  {
    provider: 'SPRIBE',
    image: `${assetBase}/newcasino/providers/spribe.png`,
  },
  {
    provider: 'Evolution Gaming',
    image: `${assetBase}/newcasino/providers/evolution.png`,
  },
  {
    provider: 'Mac88 Gaming',
    image: `${assetBase}/newcasino/providers/mac88.png`,
  },
  {
    provider: 'Ezugi',
    image: `${assetBase}/newcasino/providers/ezugi.png`,
  },
  {
    provider: 'JiLi Gaming',
    image: `${assetBase}/newcasino/providers/jili.png`,
  },
  {
    provider: 'Fun Games',
    image: `${assetBase}/newcasino/providers/fun-games.png`,
  },
  {
    provider: 'Mac88 Gaming Virtual',
    image: `${assetBase}/newcasino/providers/mac88-virtual.png`,
  },
  {
    provider: 'MAC Excite',
    image: `${assetBase}/newcasino/providers/mac-exite.png`,
  },
  {
    provider: 'Turbo Games',
    image: `${assetBase}/newcasino/providers/turbo-games.png`,
  },
  {
    provider: 'BGaming',
    image: `${assetBase}/newcasino/providers/b-gaming.png`,
  },
  {
    provider: 'Gamzix',
    image: `${assetBase}/newcasino/providers/gamzix.png`,
  },
  {
    provider: 'CRASH88 Gaming',
    image: `${assetBase}/newcasino/providers/crash.png`,
  },
  {
    provider: 'Kingmidas Gaming',
    image: `${assetBase}/newcasino/providers/kingmidas.png`,
  },
  {
    provider: 'Playtech Live',
    image: `${assetBase}/newcasino/providers/playtech.png`,
  },
  {
    provider: 'Smartsoft Gaming',
    image: `${assetBase}/newcasino/providers/smartsoft-gaming.png`,
  },
  {
    provider: 'Bombay Live',
    image: `${assetBase}/newcasino/providers/bombay-live.png`,
  },
];

export const sportsGames = [
  {
    id: 1,
    name: 'Cricket',
    image: `${assetBase}/games/cricket.jpg`,
    icon: '🏏',
    path: '/all-sports/Cricket',
    isCasino: false,
    isGames: true,
    isDisabled: false,
  },
  {
    id: 2,
    name: 'Football',
    image: `${assetBase}/games/football.jpg`,
    icon: '⚽',
    path: '/all-sports/Soccer',
    isCasino: false,
    isGames: true,
    isDisabled: false,
  },
  {
    id: 3,
    name: 'Tennis',
    image: `${assetBase}/games/tennis.jpg`,
    icon: '🎾',
    path: '/all-sports/Tennis',
    isCasino: false,
    isGames: true,
    isDisabled: false,
  },
  {
    id: 4,
    name: 'Election',
    image: `${assetBase}/games/election.png`,
    icon: '🗳️',
    path: '/all-sports/Politics',
    isCasino: false,
    isGames: true,
    isDisabled: false,
  },
  {
    id: 5,
    name: 'Horse Racing',
    image: `${assetBase}/games/horseracing.jpg`,
    icon: '🏇',
    path: '/all-sports/Horse-Racing',
    isCasino: false,
    isGames: true,
    isDisabled: false,
  },
  {
    id: 6,
    name: 'Greyhound Racing',
    image: `${assetBase}/games/grayhound.jpg`,
    icon: '🐕',
    path: '/all-sports/Greyhound-Racing',
    isCasino: false,
    isGames: true,
    isDisabled: false,
  },
  {
    id: 7,
    name: 'Aura Gaming',
    image: `${assetBase}/games/auragaming.png`,
    icon: '🎰',
    path: `/casino?provider=${encodeURIComponent('Aura Gaming'.toLowerCase())}`,
    isCasino: true,
    isGames: false,
    isDisabled: false,
  },
  {
    id: 8,
    name: 'Mac88 Gaming',
    image: `${assetBase}/games/mac88gaming.png`,
    icon: '🎰',
    path: `/casino?provider=${encodeURIComponent('Mac88 Gaming'.toLowerCase())}`,
    isCasino: true,
    isGames: false,
    isDisabled: false,
  },
];

// (`/casino?provider=${encodeURIComponent(provider.toLowerCase())}`)

export const staticGameImages: Record<string, string> = {
  // MAC88
  'Teenpatti Joker One Day': `${assetBase}/newcasino/ezuki/joker-teenpatti-oneday.png`,
  'Teenpatti Joker 20-20': `${assetBase}/newcasino/ezuki/teenpatti-2020-joker.png`,
  'Poison Teenpatti 20 20': `${assetBase}/newcasino/ezuki/poison-teenpatti.png`,
  'Open Teen patti': `${assetBase}/newcasino/ezuki/open-teenpatti.png`,
  'Dragon Tiger Lion': `${assetBase}/newcasino/ezuki/dtl.png`,
  'Dream Wheel': `${assetBase}/newcasino/ezuki/dream-wheel.png`,
  Bacarrat: `${assetBase}/newcasino/ezuki/bacarrat.png`,
  '32 Cards': `${assetBase}/newcasino/ezuki/32-cards.png`,
  Roulette: `${assetBase}/newcasino/ezuki/roullete.png`,

  // AURA
  'Teenpatti 1 Day': `${assetBase}/newcasino/aura/aura-teenpattiodi.png`,
  'Teenpatti T20': `${assetBase}/newcasino/aura/aura-teenpattit20.png`,
  '32 cards casino': `${assetBase}/newcasino/aura/aura-32cards.png`,
  'Teenpatti Test': `${assetBase}/newcasino/aura/aura-teenpattitest.png`,
  '2 Card Teenpatti': `${assetBase}/newcasino/aura/aura-2cardteenpatti.png`,
  'Andar Bahar': `${assetBase}/newcasino/aura/aura-andarbahar.png`,
  '7 Up Down': `${assetBase}/newcasino/aura/aura-7updown.png`,
  'Dragon Tiger': `${assetBase}/newcasino/aura/aura-dt.png`,
  'Hi Low': `${assetBase}/newcasino/aura/highlow.webp`,
};

export const heroSlides = [
  {
    id: 1,
    image: `${assetBase}/newcasino/banner/bnr1-min.png`,
    title: 'Casino Games',
  },
  {
    id: 2,
    image: `${assetBase}/newcasino/banner/bnr2-min.png`,
    title: 'Casino Games',
  },
  {
    id: 3,
    image: `${assetBase}/newcasino/banner/bnr3-min.png`,
    title: 'Casino Games',
  },
  {
    id: 4,
    image: `${assetBase}/newcasino/banner/bnr4-min.png`,
    title: 'Casino Games',
  },
  {
    id: 5,
    image: `${assetBase}/newcasino/banner/bnr5-min.png`,
    title: 'Casino Games',
  },
];
